import React from "react";
import logo from "../assets/images/logo.png";
export default function Logo({ width }) {
  return (
    <div className="logo">
      <img src={logo} style={{backgroundColor: "rgba(76, 175, 80, 0)"}} alt="XConnect" width={width || 200} height="70px"/>
    </div>
  );
}
